import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, VStack } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import regularColors from '@/styles/colors/regular-colors';
import { APP_CONFIG, DataTest } from '@/types';
import { MarkdownBase } from '.';
import { Icon } from './Icon';
const styleMap = {
    [APP_CONFIG.COMPONENTS.ConfigBlockType.INFORMATION]: {
        color: regularColors.grey60
    },
    [APP_CONFIG.COMPONENTS.ConfigBlockType.SUCCESS]: {
        icon: 'check-circle',
        iconColor: 'green.60'
    },
    [APP_CONFIG.COMPONENTS.ConfigBlockType.WARNING]: {
        icon: 'exclamation-circle',
        iconColor: 'red.80'
    }
};
const resolveBlockStyle = (messageBlock) => {
    const getCustomStyle = (block) => {
        if ('style' in block && block.style) {
            return {
                backgroundColor: block.style.primary,
                textColor: block.style.on_primary
            };
        }
        return {};
    };
    const defaultStyle = styleMap[messageBlock.type];
    const customStyle = getCustomStyle(messageBlock);
    return {
        backgroundColor: customStyle.backgroundColor || defaultStyle.color,
        icon: defaultStyle.icon,
        iconColor: customStyle.textColor || defaultStyle.iconColor || 'green.60',
        textColor: customStyle.textColor
    };
};
const StateMessageComponent = ({ message }) => {
    const { t } = useTranslation();
    return (_jsx(Stack, Object.assign({ "data-test": DataTest.STATE_MESSAGING, spacing: '3', w: '100%' }, { children: message === null || message === void 0 ? void 0 : message.blocks.map((messageBlock, idx) => {
            const { text } = messageBlock;
            const { backgroundColor, icon, iconColor, textColor } = resolveBlockStyle(messageBlock);
            return (_jsxs(VStack, Object.assign({ bg: backgroundColor, borderRadius: '8px', color: textColor, "data-test": DataTest.STATE_MESSAGING_BLOCK, justifyContent: 'center', px: '8', py: '4', spacing: '2', w: '100%' }, { children: [icon && _jsx(Icon, { color: iconColor, name: icon, size: '35px', type: 'solid' }), _jsx(MarkdownBase, { markdown: t(text) })] }), idx));
        }) })));
};
export const StateMessage = React.memo(StateMessageComponent);
